/**
 * A KPI band word from CVCE -> the canonical band colour variables
 * (`src/styles/brand/kpi_bands.css`, a mirror of claude-workspace
 * `charts-spec/scripts/band_colors.py`). The band itself is CVCE's; this only
 * picks the paint. An unknown or missing band renders as "no target" grey.
 */
const SLUG: Record<string, string> = {
  Outstanding: "outstanding",
  Excellent: "excellent",
  Good: "good",
  "@ Risk": "at-risk",
  Critical: "critical",
};

export type BandPaint = { solid: string; shade: string; known: boolean };

export function bandPaint(band: string | null | undefined): BandPaint {
  const slug = band ? SLUG[band] : undefined;
  if (!slug) return { solid: "var(--ks-band-no-target)", shade: "transparent", known: false };
  return { solid: `var(--ks-band-${slug})`, shade: `var(--ks-band-${slug}-shade)`, known: true };
}
